'use client';

import { FavoriteCategoryPage } from 'app/(main)/accounts/profiles/setting/favorite-category/FavoriteCategoryPage';

export default function Page() {
  return (
    <>
      <title>선호 장르 설정 | 디리토</title>
      <FavoriteCategoryPage />
    </>
  );
}
